exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-block[data-v-5b025a4e]{border:1px solid #fff!important}.rango0[data-v-5b025a4e]{background-color:hsla(0,1%,68%,.81)}.bg-baja[data-v-5b025a4e]{background-color:#225ea8}.bg-baja[data-v-5b025a4e],.bg-media[data-v-5b025a4e]{border:0 solid #fff!important;color:#fff;padding-left:10px;padding-right:10px}.bg-media[data-v-5b025a4e]{background-color:#4cb6c4}.bg-alta[data-v-5b025a4e]{background-color:#a1dab4}.bg-alta[data-v-5b025a4e],.bg-muyAlta[data-v-5b025a4e]{color:#fff;border:0 solid #fff!important;padding-left:10px;padding-right:10px}.bg-muyAlta[data-v-5b025a4e]{background-color:#fcdd82}.is-blue[data-v-5b025a4e]{background-color:#a8c2ef!important;color:#fff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b025a4e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cultura/ResulParte1.vue
// module id = 1089
// module chunks = 2